import type { TenantListItem } from '@/stores/tenant';

const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;

export interface TenantDisplay {
  name: string;
  brandColor: string | null;
}

export function getTenantBrandColorFromSettings(settings?: Record<string, unknown>): string | null {
  if (!settings) return null;
  const color = settings.brandColor;
  return typeof color === 'string' && HEX_COLOR_REGEX.test(color) ? color : null;
}

export function buildTenantDisplayMap(tenantList: TenantListItem[]): Map<string, TenantDisplay> {
  return new Map(
    tenantList.map(tenant => [
      tenant.id,
      {
        name: tenant.name,
        brandColor: getTenantBrandColorFromSettings(tenant.settings),
      },
    ])
  );
}

export function getTenantDisplayById(
  tenantId: string | null | undefined,
  tenantMap: Map<string, TenantDisplay>
): TenantDisplay {
  if (!tenantId) {
    return { name: 'Unknown tenant', brandColor: null };
  }

  return tenantMap.get(tenantId) ?? { name: 'Unknown tenant', brandColor: null };
}
